"use client"

import React, { useEffect, useState } from "react";
import { Chrome } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import {
  detectExtensionInstalled,
  getChromeWebStoreUrl,
  markInstallPromptShownThisSession,
  wasInstallPromptShownThisSession,
} from "@/lib/extension";

/*
 * Dialog that prompts the user to install the Chrome extension.
 * Render this near the top of pages where the extension is expected.
 */
export function ExtensionInstallDialog() {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const alreadyShown = wasInstallPromptShownThisSession();
    const installed = detectExtensionInstalled();
    if (!alreadyShown && !installed) {
      setOpen(true);
    }
    setChecked(true);
  }, []);

  if (!checked) return null;

  return (
    <Dialog open={open} onOpenChange={(isOpen)=>{
        setOpen(isOpen);
        if(!isOpen) {
            markInstallPromptShownThisSession();
        }
    }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Get your AI browser agent</DialogTitle>
          <DialogDescription>
            Automate multi-step web workflows, fill forms with saved snippets.
          </DialogDescription>
        </DialogHeader>

        <div className="flex items-center gap-4 rounded-md border p-4">
          <div className="rounded-md bg-primary/10 text-primary p-2">
            <Chrome className="h-5 w-5" />
          </div>
          <div className="space-y-1">
            <p className="text-sm font-medium">FillApp AI Browser Agent</p>
            <p className="text-sm text-muted-foreground">
              Works where you work. No setup required.
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={() => {
              setOpen(false);
            }}
          >
            Not now
          </Button>
          <Button
            data-custom-id="add_to_chrome"
            data-custom-event-source="extension-install-dialog"
            autoFocus
            variant="default"
            onClick={() => {
              const url = getChromeWebStoreUrl();
              window.open(url, "_blank");
              toast.success("Opening Chrome Web Store…");
              setOpen(false);
            }}
          >
            <Chrome className="h-4 w-4 mr-2" /> Add to Chrome
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ExtensionInstallDialog;


